<template>
  <div>
    <Breadcrumbs main="" title="Firebase IAP Log"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-header firebase-header">
              <h5>IAP Log (Firebase)</h5>
            </div>
            <div class="card-body custom-scrollbar">
              <div class="todo">
                <div class="todo-list-wrapper">
                  <div class="todo-list-container">
                    <div class="table-responsive datatable-vue m-0 vue-smart">                                      
                      <v-table
                        :data="todolist" class="table"
                        :currentPage.sync="basic.currentPage"
                        :pageSize="10"
                        @totalPagesChanged="basic.totalPages = $event"
                      >
                        <thead slot="head">
                          <th>User</th>
                          <th>Cost</th>
                          <th>Market</th>
                          <th>Order Id(Product Id)</th>
                          <th>Signature</th>
                          <th>Token</th>
                          <th>Purchase Date</th>
                          <th>Created Date</th>
                          <th>Status</th>
                        </thead>
                        <tbody slot="body" slot-scope="{displayData}">
                          <tr v-for="(todo, index) in displayData" :key="index" class="task"  :class="{'completed':todo.status == 'complete'}">                            
                            <td>
                              <b-badge pill variant="success">{{ todo.userUid }}</b-badge>                                      
                            </td>
                            <td>${{ todo.cost }}</td>
                            <td class="text-center">
                              <img class="img-20 img-fluid m-r-5" :src="require(`../../assets/images/market/${todo.market}.png`)" :alt="todo.market">                                    
                            </td>
                            <td>{{ todo.purchaseOrderId }} <br>({{ todo.productId }})</td>
                            <td>
                              <span class="action-box large complete-btn" :title='todo.purchaseSignature'>
                                <b-badge pill variant="success">Signature</b-badge>
                              </span>                                    
                            </td>
                            <td>
                              <span class="action-box large complete-btn" :title='todo.purchaseToken'>
                                <b-badge pill variant="success">Token</b-badge>
                              </span>
                            </td>
                            <td>{{ todo.purchaseDate }}</td>
                            <td>{{ todo.created }}</td>
                            <td>
                              <span class="action-box large complete-btn" title="Change status">
                                <b-badge v-if="todo.status=='OK'" pill variant="success">{{ todo.status }}</b-badge>
                                <b-badge v-else pill variant="success">{{ todo.status }}</b-badge>
                              </span>                                     
                            </td>
                          </tr>
                        </tbody>
                      </v-table>      

                      <smart-pagination
                          :currentPage.sync="basic.currentPage"
                          :totalPages="basic.totalPages"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <notifications classes="task" group="Todolist" />
                </div>
              </div>

              <!-- HTML Template for tasks-->
              <script id="task-template " type="tect/template">
                <li class="task">
                  <div class="task-container">
                    <h4 class="task-label"></h4>
                    <span class="task-action-btn">
                      <span class="action-box large delete-btn" title="Delete Task">
                        <i class="icon"><i class="icon-trash"></i></i>
                      </span>
                      <span class="action-box large complete-btn" title="Mark Complete">
                        <i class="icon"><i class="icon-check"></i></i>
                      </span>
                    </span>
                  </div>
                </li>
              </script>
            </div>
          </div>                
        </div>
      </div>
    </div>         
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    name:'todo',
    data(){
      return {

        basic:{
          currentPage: 1,
          totalPages: 0,
        },

        filter:{
          currentPage: 1,
          totalPages: 0,
        },

        selectrow:{
          currentPage: 1,
          totalPages: 0,
        },

        selectedRows: [],        

        filters: {
            userUid: { value: '', keys: ['userUid'] },
            cost: { value: '', keys: ['cost'] },
            market: { value: '', keys: ['market'] },
            productId: { value: '', keys: ['productId'] },
            purchaseOrderId: { value: '', keys: ['purchaseOrderId'] },
            purchaseSignature: { value: '', keys: ['purchaseSignature'] },
            purchaseToken: { value: '', keys: ['purchaseToken'] },
            purchaseDate: { value: '', keys: ['purchaseDate'] },
            developerPayload: { value: '', keys: ['developerPayload'] },
            created: { value: '', keys: ['created'] },
            status: { value: '', keys: ['status'] }
        }  
      }
    },

    computed: {
      ...mapState({
        todolist: state => state.firebase_iaplog.todo
      }),
      formatted(){
        return Vue.filter('date')(this.value)
      }      
    },
    created(){
      this.retrieveTodos();
      //this.$toasted.show("Task has been retrieved.",{theme:'outline', type : 'success',duration:2000});
    },

    methods:{
      retrieveTodos()
      {
        this.$store.dispatch('firebase_iaplog/retrieveTodos')        
      },
      tododelete(id)
      {
        this.$store.dispatch('firebase_iaplog/tododelete', id)
        this.retrieveTodos();
        this.$toasted.show("Task has been deleted.",{theme:'outline', type : 'success',duration:2000});
      }
    }
  }
</script>